import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class ConfigCompaniesStore {
  constructor (rootStore) {
    this.state = {
      companies: [],
      isFetching: false,
      selectedCompany: {
        id: '',
        name: '',
        cnpj: '',
        products: [],
        branches: [],
        currentProducts: [],
        nextBranchId: ''
      },
      newCompany: {
        id: '',
        name: '',
        cnpj: '',
        products: []
      },
      selectedBranches: [],
      editModalIsActive: false,
      newModalIsActive: false,
      branchModalIsActive: false,
      addBranchModalIsActive: false,
      isUpdating: false,
      isCreating: false,
      isCreatingBranch: false,
      isUpdatingBranch: false,
      newBranch: {
        name: '',
        idCliente: '',
        certificado: '',
        senha_certificado: '',
        dir_xml: '',
        email: '',
        uf: '',
        cnpj: '',
      },
      editBranch: {
        id: '',
        name: '',
        idCliente: '',
        certificado: '',
        senha_certificado: '',
        dir_xml: '',
        email: '',
        uf: '',
        cnpj: '',
      },
      editBranchModalIsActive: false
    }
    this.stores = rootStore.stores
  }

  fetchAllCompanies () {
    this.state.isFetching = true
    const url = process.env.REACT_APP_AWS_URL + '/getAllCompanies/'
    axios.get(url)
    .then(response => {
      this.state.companies = response.data.map(info => info.dados)
      this.state.isFetching = false
    })
    .catch(error => {
      console.log(error)
      this.state.isFetching = false
    })
  }

  handleChange (value, name) {
    this.state.selectedCompany[name] = value
  }

  setSelectedCompany (company) {
    console.log(company.products)
    this.state.selectedCompany.id = company.id
    this.state.selectedCompany.name = company.name
    this.state.selectedCompany.cnpj = company.cnpj
    this.state.selectedCompany.currentProducts = company.products
    this.state.selectedCompany.products = company.products.names
    this.state.selectedCompany.branches = company.branches
    this.state.selectedCompany.nextBranchId = company.nextBranchId
  }

  setSelectedBranches (branches) {
    this.state.selectedBranches = branches
  }

  openEditModal () {
    this.state.editModalIsActive = true
  }

  closeEditModal () {
    this.state.editModalIsActive = false
  }

  openNewModal () {
    this.state.newModalIsActive = true
  }

  closeNewModal () {
    this.state.newModalIsActive = false
  }

  openBranchModal () {
    this.state.branchModalIsActive = true
  }

  closeBranchModal () {
    this.state.branchModalIsActive = false
  }

  openAddBranchModal () {
    this.state.addBranchModalIsActive = true
  }

  closeAddBranchModal () {
    this.state.addBranchModalIsActive = false
  }

  setSelectedProducts (products) {
    this.state.selectedCompany.products = products.map(data => data.value)
  }

  setNewProducts (products) {
    this.state.newCompany.products = products.map(data => data.value)
  }

  setNewName (name) {
    this.state.newCompany.name = name
  }

  setNewCnpj (cnpj) {
    this.state.newCompany.cnpj = cnpj
  }

  setNewBranchName (name) {
    this.state.newBranch.name = name
  }

  setNewBranchIdCliente (idCliente) {
    this.state.newBranch.idCliente = idCliente
  }

  setNewBranchCertificado (certificado) {
    this.state.newBranch.certificado = certificado
  }

  setNewBranchSenhaCertificado (senhaCertificado) {
    this.state.newBranch.senha_certificado = senhaCertificado
  }

  setNewBranchDirXml (dirXml) {
    this.state.newBranch.dir_xml = dirXml
  }

  setNewBranchEmail (email) {
    this.state.newBranch.email = email
  }

  setNewBranchUf (uf) {
    this.state.newBranch.uf = uf
  }

  setNewBranchCnpj (cnpj) {
    this.state.newBranch.cnpj = cnpj
  }

  setEditBranchIdCliente (idCliente) {
    this.state.editBranch.idCliente = idCliente
  }

  setEditBranchCertificado (certificado) {
    this.state.editBranch.certificado = certificado
  }

  setEditBranchSenhaCertificado (senhaCertificado) {
    this.state.editBranch.senha_certificado = senhaCertificado
  }

  setEditBranchDirXml (dirXml) {
    this.state.editBranch.dir_xml = dirXml
  }

  setEditBranchEmail (email) {
    this.state.editBranch.email = email
  }

  setEditBranchUf (uf) {
    this.state.editBranch.uf = uf
  }

  setEditBranchCnpj (cnpj) {
    this.state.editBranch.cnpj = cnpj
  }

  updateCompany () {
    this.state.isUpdating = true
    const url = process.env.REACT_APP_AWS_URL + '/updateCompany/'
    const products = {
      names: this.state.selectedCompany.products.map(data => {
        return data
      }),
    }
    this.state.selectedCompany.products.map(data => {
      if (this.state.selectedCompany.currentProducts[data]) {
        if (this.state.selectedCompany.currentProducts[data].name === data) {
          products[data] = {
            name: data,
            data: this.state.selectedCompany.currentProducts[data].data
          }
        }
      } else {
        products[data] = {
          name: data,
          data: {}
        }
      }
    })

    const updatedCompany = {
      id: this.state.selectedCompany.id,
      name: this.state.selectedCompany.name,
      cnpj: this.state.selectedCompany.cnpj,
      products: products,
      branches: this.state.selectedCompany.branches,
      nextBranchId: this.state.selectedCompany.nextBranchId
    }
    axios.post(url, updatedCompany)
      .then(response => {
        console.log(response)
        this.state.companies = this.state.companies.filter(data => data.id !== updatedCompany.id)
        this.state.companies.push(updatedCompany)
        this.state.isUpdating = false
        this.state.editModalIsActive = false
      })
      .catch(error => {
        console.log(error)
        this.state.isUpdating = false
      })
  }

  createCompany () {
    this.state.isCreating = true
    const url = process.env.REACT_APP_AWS_URL + '/createCompany/'
    const products = {
      names: this.state.newCompany.products.map(data => {
        return data
      }),
    }
    this.state.newCompany.products.map(data => {
      products[data] = {
        name: data,
        data: {
          downloads: []
        }
      }
    })
    const newCompany = {
      id: this.state.newCompany.name.toUpperCase().replace(' ', '_'),
      name: this.state.newCompany.name,
      cnpj: this.state.newCompany.cnpj,
      products: products,
      branches: [],
      nextBranchId: 1
    }
    axios.post(url, newCompany)
      .then(response => {
        this.state.companies.push(newCompany)
        this.state.isCreating = false
        this.state.newModalIsActive = false
        this.resetNewCompany()
      })
      .catch(error => {
        console.log(error)
        this.state.isCreating = false
      })
  }

  createBranch () {
    this.state.isCreatingBranch = true
    if (!this.state.newBranch.name) {
      this.stores.notificationStore.sendErrorNotification('Erro!', 'Digite o nome da filial')
      this.state.isCreatingBranch = false
      return
    }
    const products = {
      names: this.state.selectedCompany.products.map(data => {
        return data
      }),
    }
    this.state.selectedCompany.products.map(data => {
      if (this.state.selectedCompany.currentProducts[data]) {
        if (this.state.selectedCompany.currentProducts[data].name === data) {
          products[data] = {
            name: data,
            data: this.state.selectedCompany.currentProducts[data].data
          }
        }
      } else {
        products[data] = {
          name: data,
          data: {}
        }
      }
    })
    const url = process.env.REACT_APP_AWS_URL + '/createBranch/'
    const company = {
      id: this.state.selectedCompany.id,
      name: this.state.selectedCompany.name,
      cnpj: this.state.selectedCompany.cnpj,
      products: products,
      branches: this.state.selectedCompany.branches,
      nextBranchId: this.state.selectedCompany.nextBranchId++
    }
    company.branches.push({
      id: company.nextBranchId,
      name: this.state.newBranch.name,
      idCliente: this.state.newBranch.idCliente,
      certificado: this.state.newBranch.certificado,
      senha_certificado: this.state.newBranch.senha_certificado,
      dir_xml: this.state.newBranch.dir_xml,
      email: this.state.newBranch.email,
      uf: this.state.newBranch.uf,
      cnpj: this.state.newBranch.cnpj,
    })
    axios.post(url, company)
      .then(response => {
        console.log(response)
        this.state.companies = this.state.companies.filter(data => data.id !== response.data.id)
        this.state.companies.push(response.data)
        this.closeAddBranchModal()
        this.openBranchModal()
        this.state.newBranch.name = ''
        this.state.isCreatingBranch = false
      })
      .catch(error => {
        console.log(error)
        this.state.isCreatingBranch = false
      })
  }

  setEditBranch (branch) {
    this.state.editBranch.id = branch.id
    this.state.editBranch.name = branch.name
    this.state.editBranch.idCliente = branch.idCliente
    this.state.editBranch.certificado = branch.certificado
    this.state.editBranch.senha_certificado = branch.senha_certificado
    this.state.editBranch.dir_xml = branch.dir_xml
    this.state.editBranch.email = branch.email
    this.state.editBranch.uf = branch.uf
    this.state.editBranch.cnpj = branch.cnpj
  }

  setEditBranchName (name) {
    this.state.editBranch.name = name
  }

  openEditBranchModal () {
    this.state.editBranchModalIsActive = true
  }

  closeEditBranchModal () {
    this.state.editBranchModalIsActive = false
  }

  updateBranch () {
    this.state.isUpdatingBranch = true
    if (!this.state.editBranch.name) {
      this.stores.notificationStore.sendErrorNotification('Erro!', 'Digite o nome da filial')
      this.state.isUpdatingBranch = false
      return
    }
    const products = {
      names: this.state.selectedCompany.products.map(data => {
        return data
      }),
    }
    this.state.selectedCompany.products.map(data => {
      if (this.state.selectedCompany.currentProducts[data]) {
        if (this.state.selectedCompany.currentProducts[data].name === data) {
          products[data] = {
            name: data,
            data: this.state.selectedCompany.currentProducts[data].data
          }
        }
      } else {
        products[data] = {
          name: data,
          data: {}
        }
      }
    })
    const url = process.env.REACT_APP_AWS_URL + '/updateBranch/'
    const branchToUpdate = this.state.selectedCompany.branches.find(data => data.id === this.state.editBranch.id)
    branchToUpdate.id = this.state.editBranch.id
    branchToUpdate.name = this.state.editBranch.name
    branchToUpdate.idCliente = this.state.editBranch.idCliente
    branchToUpdate.certificado = this.state.editBranch.certificado
    branchToUpdate.senha_certificado = this.state.editBranch.senha_certificado
    branchToUpdate.dir_xml = this.state.editBranch.dir_xml
    branchToUpdate.email = this.state.editBranch.email
    branchToUpdate.uf = this.state.editBranch.uf
    branchToUpdate.cnpj = this.state.editBranch.cnpj

    const company = {
      id: this.state.selectedCompany.id,
      name: this.state.selectedCompany.name,
      cnpj: this.state.selectedCompany.cnpj,
      products: products,
      branches: this.state.selectedCompany.branches,
      nextBranchId: this.state.selectedCompany.nextBranchId
    }
    axios.post(url, company)
      .then(response => {
        console.log(response)
        this.closeEditBranchModal()
        this.openBranchModal()
        this.state.isUpdatingBranch = false
      })
      .catch(error => {
        console.log(error)
        this.state.isUpdatingBranch = false
      })
  }

  resetNewCompany () {
    this.state.newCompany = {
      id: '',
      name: '',
      cnpj: '',
      products: []
    }
  }

  resetNewBranch () {
    this.state.newBranch = {
      name: '',
      idCliente: '',
      certificado: '',
      senha_certificado: '',
      dir_xml: '',
      email: '',
      uf: '',
      cnpj: '',
    }
  }
}

decorate(ConfigCompaniesStore, {
  state: observable,
  fetchAllCompanies: action,
  handleChange: action,
  setSelectedCompany: action,
  openEditModal: action,
  closeEditModal: action,
  setSelectedProducts: action
})

export default ConfigCompaniesStore



// WEBPACK FOOTER //
// ./src/stores/config/companies/configCompaniesStore.js